import {Turn, Align} from './index.h'

export class LookaheadAlign {
  turn: Turn
  alignSide: Align
  distance: number
  constructor({
    turn,
    alignSide,
    distance
  }: {
    turn: Turn
    alignSide: Align
    distance: number
  }) {
    this.turn = turn
    this.alignSide = alignSide
    this.distance = distance
  }
}
